import React, { useEffect } from 'react';
import Icon from './Icon.js';

/**
 * Vista ampliada de cartel / foto de publicación Comunidad.
 * @param {{ open: boolean, imageUrl: string|null, title?: string|null, onClose: () => void }} props
 */
export default function ComunidadPosterLightbox({ open, imageUrl, title, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open || !imageUrl) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title ? `Cartel: ${title}` : 'Cartel ampliado'}
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: 'rgba(5,5,10,0.94)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 16px 24px',
        boxSizing: 'border-box',
      }}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Cerrar"
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: '0.5px solid rgba(255,255,255,0.2)',
          background: 'rgba(0,0,0,0.55)',
          color: '#fff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name="x" size={18} color="#fff" />
      </button>

      {title ? (
        <div
          style={{
            position: 'absolute',
            top: 20,
            left: 16,
            right: 56,
            fontSize: 13,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.85)',
            lineHeight: 1.35,
            textAlign: 'center',
            pointerEvents: 'none',
          }}
        >
          {title}
        </div>
      ) : null}

      <div
        onClick={e => e.stopPropagation()}
        style={{
          flex: 1,
          width: '100%',
          maxWidth: 920,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 0,
        }}
      >
        <img
          src={imageUrl}
          alt={title ? `Cartel: ${title}` : 'Cartel del evento'}
          style={{
            maxWidth: 'min(96vw, 920px)',
            maxHeight: 'min(82vh, 880px)',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
            borderRadius: 8,
            boxShadow: '0 12px 48px rgba(0,0,0,0.55)',
          }}
        />
      </div>

      <p
        style={{
          margin: '12px 0 0',
          fontSize: 11,
          color: 'rgba(255,255,255,0.45)',
          pointerEvents: 'none',
        }}
      >
        Pulsa fuera de la imagen o Esc para cerrar
      </p>
    </div>
  );
}
